import React, { useEffect, useState } from "react";
import AdvanceIntroductionPage from "./AdvanceIntroductionPage";
import AdvanceScreeningQA from "./AdvanceScreeningQA";
import AdvanceReport from "./AdvanceReport";
import { useLocation } from "react-router-dom";

function AdvanceScreening() {
  const location = useLocation();
  const [advanceIntroPage, setAdvanceIntroPage] = useState();

  useEffect(() => {
    // location.state.activeScreeningCategoryID !== 2 this condition add to show advance screening introduction
    // when user start advance screening journey after complete profiler form on click Advance Screening button instead of I will do it later
    if (
      location.state.currentScreeningStatus === "Pending" &&
      location.state.activeScreeningCategoryID !== 2
    ) {
      setAdvanceIntroPage(false);
    } else {
      setAdvanceIntroPage(true);
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J"))
      ) {
        e.preventDefault();
      }

      // Disable Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+P
      if (
        e.ctrlKey &&
        ["a", "c", "v", "x", "p"].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <>
      {advanceIntroPage ? (
        <>
          <AdvanceIntroductionPage setAdvanceIntroPage={setAdvanceIntroPage} />
        </>
      ) : (
        <>
          <AdvanceScreeningQA />
        </>
      )}
      {/* <AdvanceIntroductionPage /> */}
      {/* <AdvanceReport /> */}
    </>
  );
}

export default AdvanceScreening;
